export enum DegreeTypeText {
	MASTER = "Master's",
	PHD = 'PhD',
	BACHELOR = "Bachelor's"
}
